import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Select,
  ModalFooter,
  Button,
} from "@chakra-ui/react";
import CampaignTypes from "./CampaignTypes";
import {phoneCapableCampaigns} from "./CampaignConstants";

const AddCampaignModal = ({
  isOpen,
  onClose,
  campaignType,
  campaignMedium,
  campaignCategory,
  handleCampaignTypeChange,
  handleCampaignMediumChange,
  setCampaignCategory,
  categories,
  createCampaign,
  resetData,
  canCreateCampaigns = true,
  hasLeadAds = false,
  hasManualLeadAdsDrip = false,
}) => {
  // Hide the lead-ads option entirely when a manual lead-ads drip campaign
  // already exists for this business. Only one manual drip is supported right
  // now — backend routing isn't deterministic across multiple manual drips.
  const availableTypes = CampaignTypes.filter(ct => {
    if (ct.id === 'lead-ads') return hasLeadAds && !hasManualLeadAdsDrip;
    return canCreateCampaigns;
  });
  
  const getCategories = () => {
    if (campaignMedium === "SMS" && campaignType === "reminder") {
      return ['Reminder', 'Confirmation'].map((category,index)=>(
          <option key={index} value={category}>
            {category}
          </option>
      ));
    } else if (campaignMedium === "Phone" && campaignType === "manual") {
      return ['Build Your Own Campaign'].map((category,index)=>(
        <option key={index} value={category}>
          {category}
        </option>
      ));
    }
    
    return categories?.filter((category) =>
      new RegExp(`${campaignType}|build`, "i").test(
        category.name.toLowerCase()
      )
    )
    .map((category, index) => (
      <option key={index} value={category.id}>
        {category.name}
      </option>
    ));
  };
  
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create New Campaign</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Type</FormLabel>
            <Select
              placeholder="Select type"
              value={campaignType}
              onChange={handleCampaignTypeChange}
            >
              {availableTypes.map((ct, index) => (
                <option key={index} value={ct.id}>
                  {ct.name}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl mt={4} isDisabled={!campaignType || campaignType === 'lead-ads'}>
            <FormLabel>Medium</FormLabel>
            <Select
              placeholder="Select medium"
              value={campaignMedium}
              onChange={handleCampaignMediumChange}
            >
              <option value="Email">Email</option>
              <option value="SMS">Text Message</option>
              {phoneCapableCampaigns.includes(campaignType) && (
                <option value="Phone">Phone</option>
              )}
            </Select>
          </FormControl>
          <FormControl mt={4} isDisabled={
            !campaignMedium ||
            campaignType === 'lead-ads' ||
            (campaignMedium === "Phone" && campaignType !== 'manual') ||
            (campaignMedium === "SMS" && campaignType !== 'reminder')}>
            <FormLabel>Category</FormLabel>
            <Select
              placeholder="Select category"
              value={campaignCategory}
              onChange={(e) => setCampaignCategory(e.target.value)}
            >
              {getCategories()}
            </Select>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            onClick={() => {
              onClose();
              resetData();
            }}
          >
            Cancel
          </Button>
          <Button
            marginLeft="10px"
            colorScheme="blue"
            mr={3}
            onClick={createCampaign}
            isDisabled={
              !(
                campaignType &&
                (campaignType === 'lead-ads' ||
                (campaignMedium &&
                (
                  (campaignMedium === 'SMS' && ((campaignType === 'reminder' && campaignCategory) || campaignType !== 'reminder')) ||
                  (campaignMedium === 'Email' && campaignCategory) ||
                  (campaignMedium === "Phone"))))
              )
            }
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddCampaignModal;
